<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.areaId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Regiões
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-bind:href="'#t2' + rowData.areaId + ''"
            role="tab"
            data-toggle="tab"
            v-if="rowData.areaPallet.length > 0"
          >
            <span class="nav-link-in">
              Pallets
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.areaId + ''"
          v-if="rowData.areaRegiao.length > 0"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 33%">Código</th>
                <th style="width: 33%">Descrição</th>
                <th style="width: 33%">Status</th>
              </tr>
            </thead>
            <tbody>
              <template
                v-if="rowData.areaRegiao.length > 0"
                v-for="(item, i) in rowData.areaRegiao"
              >
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    <span v-b-tooltip.hover.rightbottom>
                      {{ item.regiao.cd }}
                    </span>
                  </td>
                  <td>
                    <span v-b-tooltip.hover.rightbottom>
                      {{ item.regiao.descr }}
                    </span>
                  </td>
                  <td>
                    <span v-b-tooltip.hover.rightbottom>
                      <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                      <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                    </span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div
          role="tabpanel"
          class="tab-pane fade in"
          v-bind:id="'t2' + rowData.areaId + ''"
          v-if="rowData.areaPallet.length > 0"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 50%">Código</th>
                <th style="width: 50%">Status</th>
              </tr>
            </thead>
            <tbody>
              <template
                v-if="rowData.areaPallet.length > 0"
                v-for="(item, i) in rowData.areaPallet"
              >
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    <span v-b-tooltip.hover.rightbottom>
                      {{ item.pallet.cd }}
                    </span>
                  </td>
                  <td>
                    <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                    <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import accounting from "accounting";
import moment from "moment";

export default {
  data() {
    return {
      visibleDetailRows: [],
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    onDetail(id) {
      this.toggleDetailRow(id);
    },
    isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    formatDateHora(value, fmt = "DD/MM/YYYY HH:mm:ss") {
      return value == null
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm:ss").format(fmt);
    },
  },
};
</script>
